import {reactive, computed, toRefs, createApp} from 'vue'
import {httpPost} from '../api/http_caller.js'
import {cloneDeep} from "lodash";
import Questionario from '../components/questionario/Questionario.class.js';
import {formatDateEnToIT} from '../filters/common.filters.js'
import BaseLoader from 'fallco-frontend-framework/src/vue/plugins/BaseLoader/BaseLoader.vue'
import {createPluginInstance} from '../core/plugins/create-dynamic-instance.js'
import {useChecklistInit} from './actions/checklist-init'
import {postaNotaDoc} from "./actions/checklist.repository";

export function useQuestionario(props, router, route, checklistStore, praticaStore, emits = null) {
  const {fillAndFilterChecklist} = useChecklistInit(checklistStore, praticaStore);

  const data = reactive({
    questionariRichiesti: [],
    isSyncRisposteCompletato: false,
    abilitaDopoSyncRisposteDelQuestionario: false,
    statoDelQuestionario: props.state,
    questionari: props.questionari,
    questionariOptions: [],
    tipiDiDomande: null,
    tipiDiDomandeOptions: null,
    tipoDiQuestionario: null,
    mostraChecklistDopoFill: false,
    elementiDelQuestionarioFlat: {}
  })

  const isFront = computed(() => checklistStore.questionarioAttivo && data.statoDelQuestionario === 'front');
  const isReadonly = computed(() => checklistStore.questionarioAttivo && data.statoDelQuestionario === 'readonly');
  const isAdmin = computed(() => checklistStore.questionarioAttivo && data.statoDelQuestionario === 'admin');
  const isPreview = computed(() => checklistStore.questionarioAttivo && data.statoDelQuestionario === 'preview');

  const noteQuestionario = computed(() => {
    let intestazione = '<span class="crm:whitespace-pre"><p class="text-primary crm:uppercase"><strong>Istruzioni operative a beneficio del cliente</strong></p>';
    intestazione = (checklistStore.questionarioAttivo) ? intestazione + checklistStore.questionarioAttivo.atom_components.note : intestazione;
    return intestazione + '</span>'
  })

  const titoloDellaChecklist = computed(() => {
    let titolo = (praticaStore.utenteConnesso !== 'notaio') ? 'Richiesta ricevuta' : 'Checklist inviata';
    return titolo + ' il ' + formatDateEnToIT(checklistStore.questionarioAttivo.created_at);
  })

  /**
   * Posta tutte le note aggiunte del questionario
   * @returns {boolean}
   */
  const invioAutomaticoNoteQuestionario = () => {
    let elementiQuestionarioAttivo = cloneDeep(checklistStore.risposteDelQuestionario);
    elementiQuestionarioAttivo.forEach(function (elementoQuestionarioAttivo) {
      if(elementoQuestionarioAttivo && elementoQuestionarioAttivo.value) {
        (elementoQuestionarioAttivo.value).forEach(function (risposta) {
          let documentoID = (risposta.document_id) ? risposta.document_id : risposta.documento_id;
          if (risposta.notaAggiunta) {
            let notaDoc = postaNotaDoc({post: httpPost}, documentoID, checklistStore.questionarioIdAttivo, risposta.notaAggiunta, praticaStore.praticaID);
            return (notaDoc && notaDoc.esito === 'ok');
          }
        });
      }
    });

    return true;
  }

  /**
   * Inizializzazione del Questionario
   * @param questionarioOBJ
   */
  const initQuestionario = async (questionarioOBJ) => {
    if (questionarioOBJ && questionarioOBJ.atom_components) {
      data.abilitaDopoSyncRisposteDelQuestionario = false;

      const checklist_loader = document.createElement('div')
      const checklistLoader = createApp(BaseLoader, {});
      const checklistLoaderMount = checklistLoader.mount(checklist_loader)
      checklistLoaderMount.setTeleportTo('#front-loader-readonly', 'target')
      checklistLoaderMount.show();

      // Estraggo le domande del questionario e mi creo oggetti clone per successive operazioni
      let questionarioElements;
      if ((data.statoDelQuestionario === 'readonly') || data.statoDelQuestionario === 'front') {
        questionarioElements = questionarioOBJ.atom_components.elements;
      } else {
        questionarioElements = cloneDeep(Questionario._init(questionarioOBJ.atom_components.elements, (data.statoDelQuestionario !== 'front' && data.statoDelQuestionario !== 'readonly')));
      }

      // Estraggo il template del questionario senza gli elementi per facilitare le modifiche generali al questionario
      let questionarioTemplate = cloneDeep(data.questionari[0]);
      questionarioTemplate.atom_components.elements = [];

      checklistStore.questionarioTemplate = questionarioTemplate
      checklistStore.questionarioAttivo = cloneDeep(questionarioTemplate)
      checklistStore.questionarioIdAttivo = questionarioOBJ.questionario_id
      checklistStore.questionarioAttivoStatus = String(data.statoDelQuestionario)

      if (data.statoDelQuestionario === 'front' || data.statoDelQuestionario === 'readonly') {
        await fillAndFilterChecklist(questionarioOBJ, questionarioElements, data.statoDelQuestionario, props.mostraSoloAccettati);
      } else {
        if (!checklistStore.risposteDelQuestionario || Object.keys(checklistStore.risposteDelQuestionario).length < 1) {
          checklistStore.risposteDelQuestionario = cloneDeep(questionarioElements)
        }
      }

      checklistStore.questionarioDefault = cloneDeep(questionarioElements)
      if (data.statoDelQuestionario === 'front') {
        data.elementiDelQuestionarioFlat = Questionario._composeQuestionarioFlat(cloneDeep(checklistStore.risposteDelQuestionario));
      }

      checklistStore.questionario = questionarioElements

      setTimeout(() => {
        checklistLoaderMount.hide();
        checklistLoader.unmount();
        data.abilitaDopoSyncRisposteDelQuestionario = true;
      }, 1000)
    }
  }

  const init = async () => {
    await initQuestionario(cloneDeep(props.questionari[Object.keys(props.questionari)[0]]));

    // await tipiDomande();

    data.mostraChecklistDopoFill = true;
  }

  async function inviaQuestionarioAlNotaio() {
    let inviaNoteResponse = invioAutomaticoNoteQuestionario();

    if (inviaNoteResponse) {
      let chiudiQuestionario = await httpPost('Questionario', 'chiudiQuestionario',
        {questionario_id: checklistStore.questionarioAttivo.questionario_id, pratica_id: praticaStore.praticaID},
        {headers: {"Content-Type": "multipart/form-data"}});

      if (chiudiQuestionario && chiudiQuestionario.esito === 'ok') {
        checklistStore.questionarioAttivo = {}
        emits('chiudiQuestionario', {})
      }
    }
  }

  /**
   * Lato Cittadino
   */
  const salvaBozzaQuestionario = () => {
    invioAutomaticoNoteQuestionario();
    emits('chiudiBozzaQuestionario');
  }

  /**
   * Lato notaio
   */
  const salvaBozzaQuestionarioLatoNotaio= () => {
    invioAutomaticoNoteQuestionario();
    emits('onChiudiModaleValidazioneChecklist', 'questionario_readonly');
  }

  /**
   *
   * @param praticaTabsInstance
   * @param modaleQuestionarioCittadino
   * @return {Promise<void>}
   */
  const chiudiQuestionario = async (praticaTabsInstance, modaleQuestionarioCittadino) => {
    const chiudi_questionario_instance = createPluginInstance(BaseLoader)
    chiudi_questionario_instance.mount.show();

    checklistStore.isQuestionariDaCompletare = false

    modaleQuestionarioCittadino.close();

    await praticaStore.onReInitPratica();
    await checklistStore.onResponseQuestionariRichiesti();

    praticaTabsInstance.toggle('documenti');

    chiudi_questionario_instance.mount.hide();
    chiudi_questionario_instance.app.unmount();
  }

  const concludiValidazione = async (modalRef) => {
    const concludi_validazione_loader = document.createElement('div')
    const concludiValidazioneLoader = createApp(BaseLoader, {});
    const concludiValidazioneLoaderMount = concludiValidazioneLoader.mount(concludi_validazione_loader)
    concludiValidazioneLoaderMount.show();

    let setQuestionarioValidato = await httpPost('Questionario', 'setQuestionarioValidato',
      {questionario_id: checklistStore.questionarioIdAttivo, pratica_id: praticaStore.praticaID}, {
      loading: false, custom_message: 'Validazione checklist conclusa con successo'
    });

    if (setQuestionarioValidato.esito === 'ok') {
      invioAutomaticoNoteQuestionario();
    }

    if (setQuestionarioValidato && setQuestionarioValidato.esito === 'ok') {
      emits('onConcludiValidazione', modalRef);
    }

    await praticaStore.onReInitPratica();

    concludiValidazioneLoaderMount.hide();
    concludiValidazioneLoader.unmount();
  }

  /**
   * Operazioni da eseguire dopo la conclusione della validazione
   * @param praticaTabsInstance
   * @param modaleRiepilogoRisposteChecklist
   */
  function dopoConclusioneValidazioneChecklist(praticaTabsInstance, modaleRiepilogoRisposteChecklist) {
    const conclusione_validazione_checklist_instance = createPluginInstance(BaseLoader)
    conclusione_validazione_checklist_instance.mount.show();

    checklistStore.notaioDaFare = [];
    modaleRiepilogoRisposteChecklist.close();
    checklistStore.onResponseQuestionariRichiesti();

    conclusione_validazione_checklist_instance.mount.hide();
    conclusione_validazione_checklist_instance.app.unmount();

    praticaTabsInstance.toggle('documenti');
  }

  /**
   * Calcola il messaggio da mostrare nel riepilogo della checklist
   * @param soggetti
   * @returns {string}
   */
  function checkListMessage(soggetti) {
    let message = 'In attesa di completamento';
    if (soggetti.checkList.is_to_do) {
      message = 'In attesa di validazione';
    }

    if (!soggetti.checkList.is_to_do && soggetti.checkList.is_completo) {
      message = 'Checklist completata';
    }

    return message;
  }

  /**
   * Apre la modale della checklist
   * @param modaleQuestionarioCittadino
   * @param modaleRiepilogoRisposteChecklist
   * @param checklist
   * @param modalToTrigger
   * @returns {Promise<void>}
   */
  async function apriDettaglioChecklist(modaleQuestionarioCittadino, modaleRiepilogoRisposteChecklist, checklist, modalToTrigger) {
    if (checklist.inviato_a) {
      modaleRiepilogoRisposteChecklist.changeTitle('Riepilogo Risposte di ' + checklist.inviato_a)
    }
    const dettaglio_checklist_instance = createPluginInstance(BaseLoader)
    dettaglio_checklist_instance.mount.show();

    await checklistStore.getQuestionariFront({soggettoId: checklist.soggetto_id, questionarioId: checklist.questionario_id});

    if(modalToTrigger === 'modaleChecklistReadonly') {
      modaleRiepilogoRisposteChecklist.changeParams({soggettoId: checklist.soggetto_id, questionarioId: checklist.questionario_id})
      modaleRiepilogoRisposteChecklist.open();
    }

    if(modalToTrigger === 'modaleChecklistCittadino') {
      modaleQuestionarioCittadino.changeParams({soggettoId: checklist.soggetto_id, questionarioId: checklist.questionario_id})
      modaleQuestionarioCittadino.open();
    }

    dettaglio_checklist_instance.mount.hide();
    dettaglio_checklist_instance.app.unmount();
  }

  return {
    ...toRefs(data),
    isFront,
    isReadonly,
    isAdmin,
    isPreview,
    titoloDellaChecklist,
    noteQuestionario,
    chiudiQuestionario,
    salvaBozzaQuestionario,
    salvaBozzaQuestionarioLatoNotaio,
    concludiValidazione,
    initQuestionario,
    inviaQuestionarioAlNotaio,
    dopoConclusioneValidazioneChecklist,
    init,
    checkListMessage,
    apriDettaglioChecklist
  }
}